import { TDocumentReference } from "common/types/FirebaseTypes";
import { FirebaseDocument } from "common/models/FirebaseDocument";
import { CustomPropertyModel } from "./CustomPropertyModel";

class Repository {
  async createProperty(
    ref: TDocumentReference,
    data: CustomPropertyModel
  ): Promise<FirebaseDocument<CustomPropertyModel>> {
    const doc = await ref.collection("customProperties").add(data.toJSON());
    return new FirebaseDocument<CustomPropertyModel>(doc.id, data);
  }

  getPropertyByLabel(
    ref: TDocumentReference,
    label: string
  ): Promise<FirebaseDocument<CustomPropertyModel>> {
    return ref
      .collection("customProperties")
      .where("label", "==", label)
      .limit(1)
      .get()
      .then((snapshot) => {
        const doc = snapshot.docs[0];
        return doc && CustomPropertyModel.createFrom(doc);
      });
  }

  getAllProperties(
    ref: TDocumentReference
  ): Promise<FirebaseDocument<CustomPropertyModel>[]> {
    return ref
      .collection("customProperties")
      .orderBy("label", "asc")
      .get()
      .then((snapshot) =>
        snapshot.docs.map((doc) => CustomPropertyModel.createFrom(doc))
      );
  }

  deleteProperty(ref: TDocumentReference, id: string): Promise<void> {
    return ref.collection("customProperties").doc(id).delete();
  }

  updateProperty(
    ref: TDocumentReference,
    doc: FirebaseDocument<CustomPropertyModel>
  ): Promise<void> {
    const updatedData = { ...doc.data.toJSON() };
    return ref.collection("customProperties").doc(doc.id).update(updatedData);
  }
}

export const CustomPropertyRepository = new Repository();



// WEBPACK FOOTER //
// ./src/modules/customProperties/CustomPropertyRepository.ts